/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { getPackingListConfig } from "api/services/location";
import { GetPackingListConfigResponseType } from "api/response/location.response";
import { useCustomQuery } from "hooks/useCustomQuery";
import { locationQueryKeys } from "./locationQueryKeys";

export const useGetPackingListConfig = (
  location: string,
  options?: UseQueryOptions<GetPackingListConfigResponseType, unknown>,
): UseQueryResult<GetPackingListConfigResponseType> =>
  useCustomQuery<GetPackingListConfigResponseType>({
    queryKey: locationQueryKeys.packingListConfig(location),
    queryFn: () => getPackingListConfig(location).then((res) => res.data),
    ...options,
  });
